import { motion } from 'framer-motion';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      icon: 'ri-chat-3-line',
      title: 'Cuéntanos tu caso',
      description: 'Completa el formulario o contáctanos para evaluar tu situación y orientarte correctamente.',
    },
    {
      number: '02',
      icon: 'ri-search-eye-line',
      title: 'Revisamos y gestionamos',
      description: 'Analizamos los antecedentes y nos encargamos de todo el proceso legal según tu caso.',
    },
    {
      number: '03',
      icon: 'ri-shield-check-line',
      title: 'Avanzas sin complicaciones',
      description: 'Te acompañamos hasta completar el trámite y puedas disponer de los bienes sin problemas.',
    },
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Subtle Arrow Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M30 10 L40 30 L30 50\' stroke=\'%23FFD700\' stroke-width=\'2\' fill=\'none\'/%3E%3C/svg%3E")',
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl lg:text-6xl font-bold text-black mb-4">
            Cómo funciona
          </h2>
          <p className="text-xl text-gray-medium max-w-2xl mx-auto">
            Proceso simple y eficiente en tres pasos
          </p>
        </motion.div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 relative">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              className="relative"
            >
              {/* Background Number */}
              <div className="absolute top-0 left-0 text-9xl font-black text-primary-yellow opacity-20 -z-10">
                {step.number}
              </div>

              {/* Icon Circle */}
              <div className="w-16 h-16 flex items-center justify-center bg-black rounded-full mb-6 relative z-10">
                <i className={`${step.icon} text-3xl text-primary-yellow`}></i>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-black mb-4">
                {step.title}
              </h3>
              <p className="text-gray-medium text-base leading-relaxed">
                {step.description}
              </p>

              {/* Connecting Arrow (hidden on mobile and last item) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 -right-6 lg:-right-10 w-12 lg:w-20 h-0.5 bg-primary-yellow">
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
                    <div className="w-0 h-0 border-t-4 border-t-transparent border-l-8 border-l-primary-yellow border-b-4 border-b-transparent"></div>
                  </div>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        {/* Timeline Visual */}
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 1 }}
          className="mt-16 relative"
        >
          <div className="h-1 bg-primary-yellow rounded-full relative">
            {/* Progress Points */}
            {[0, 50, 100].map((position, index) => (
              <motion.div
                key={index}
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.8 + index * 0.2, duration: 0.4 }}
                className="absolute top-1/2 transform -translate-y-1/2 w-4 h-4 bg-primary-yellow rounded-full border-4 border-white shadow-lg"
                style={{ left: `${position}%` }}
              ></motion.div>
            ))}
          </div>
        </motion.div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 1, duration: 0.6 }}
          className="text-center mt-16"
        >
          <p className="text-gray-medium mb-6 text-lg">
            <strong className="text-black">Acompañamiento completo</strong> en cada etapa del proceso
          </p>
          <a
            href="/contacto"
            className="inline-block bg-black text-white px-10 py-4 rounded-full font-bold hover:bg-gray-800 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            Comenzar ahora
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ProcessSection;